// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"144":"c42095c9","379":"7b3c007b","598":"ed5b6068","744":"50a15f95","948":"90a58681","985":"b803d838"}[chunkId] + ".chunk.css";
};